
import React from 'react';
import { TextField, CircularProgress, Grid, Typography, IconButton, Button } from '@material-ui/core';
import { Link, useHistory, useLocation } from 'react-router-dom';

import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import ArrowForwardSharpIcon from '@material-ui/icons/ArrowForwardSharp';
import ArrowBackSharpIcon from '@material-ui/icons/ArrowBackSharp';
import { useDispatch, useSelector } from 'react-redux';
import useStyles from './styles';
import useCommonStyles from '../../../CommonStyle/commonStyle';
import useCommonAuthStyles from '../../commonAuthStyle';
import Input from '../../Input/Input';
import { store } from '../../../../index';


interface signupProp {
    form: { firstName: string, lastName: string, spellFirstName: string, spellLastName: string, email: string, userID: string, profilePic: string, password: string, confirmPassword: string, userType: string },
    handleSubmit: ((e: React.FormEvent<HTMLFormElement>) => void),
    handleChange: ((e: React.ChangeEvent<HTMLInputElement>) => void),
    handleShowPassword: (() => void),
    handleShowRepeatPassword: (() => void),
    switchMode: (() => void),
    setSignupStep: ((value: number) => void),
    setNext: ((value: boolean) => void),
    showPassword: boolean,
    showRepeatPassword: boolean
}

type RootState = ReturnType<typeof store.getState>;

const PasswordSetup = ({ form, handleSubmit, handleChange, handleShowPassword, handleShowRepeatPassword, switchMode, setSignupStep, setNext, showPassword, showRepeatPassword }: signupProp) => {
    const classes = useStyles();
    const commonClasses = useCommonStyles();
    const commonAuthClasses = useCommonAuthStyles();
    const { isLoading, errors } = useSelector((state: RootState) => state.auth);

    return (
        <Grid container direction="row" justifyContent="center" alignItems="center" spacing={3} className={commonAuthClasses.parentGridContainer}>
            <Grid item xs={9} sm={6} md={6} className={commonAuthClasses.leftGrid}>
                <Typography className={commonAuthClasses.motivationalTitle} >
                    パスワードを設定しよう<br />
                </Typography>
                <Typography className={commonAuthClasses.subTitle}>
                    パスワードは８文字以上で、大文字・小文字・数字を全て含む必要があります。
                </Typography >
            </Grid>
            <Grid container direction="column" alignItems="center" justifyContent="center" item xs={12} sm={6} md={6}>

                <form name="passwordForm" className={classes.form} onSubmit={handleSubmit}>
                    <Grid container spacing={2}>
                        <Input
                            name="password"
                            label="パスワード"
                            handleChange={handleChange}
                            type={showPassword ? 'text' : 'password'}
                            handleShowPassword={handleShowPassword}
                            value={form.password} />
                        <Input
                            name="confirmPassword"
                            label="パスワード（確認用）"
                            handleChange={handleChange}
                            type={showRepeatPassword ? 'text' : 'password'}
                            handleShowPassword={handleShowRepeatPassword}
                            value={form.confirmPassword} />
                    </Grid>
                    <Grid container justifyContent="space-between">
                        <Button type="submit" variant="contained" color="primary" className={commonAuthClasses.submit} onClick={() => setSignupStep(1)}>
                            <ArrowBackSharpIcon color="inherit" />                            </Button>
                        <Button type="submit" variant="contained" color="primary" className={commonAuthClasses.submit} onClick={() => setNext(true)}>
                            アカウント作成
                        </Button>
                        {isLoading ?
                            <Button variant="contained" color="primary" className={commonAuthClasses.submitLoading} >
                                <CircularProgress size={24} className={commonAuthClasses.submitCircularProgress} />
                            </Button> :
                            <Button type="submit" variant="contained" color="primary" className={commonAuthClasses.submit} onClick={() => setNext(true)}>
                                アカウント作成
                            </Button>
                        }
                    </Grid>

                    <Grid container justifyContent="flex-end">
                        <Grid item>
                            <Link to="/startup/signup" className={commonAuthClasses.hintLinkBtn}>アカウントをお持ちの方はこちら</Link>
                        </Grid>
                    </Grid>

                </form>
            </Grid>

        </Grid>
    )
};

export default PasswordSetup;



